import { ui } from './ui';
import * as common from './common';

export const config = {
	...common,
	ui,
};
